import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IPC_CHANNEL } from "../../_offline/electron.constants";
import { ConnectDeviceSchema } from "../../_offline/models/connect-device.schema";
import { LoginUserOfflineService } from "../offline/login-user-offline.service";
import { DatabaseBaseService } from "../base/database-base.service";
import { ConnectDevice } from "../../_objects/connect-device";
import { ElectronService } from "../../electron.service";

@Injectable({
  providedIn: "root"
})
export class ConnectDeviceDbService extends DatabaseBaseService {
  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  getAll(): Observable<ConnectDeviceSchema> {
    return this.ipcSendSync(IPC_CHANNEL.CONNECT_DEVICE.GET_ALL);
  }

  get(deviceId: string): Observable<ConnectDeviceSchema> {
    return this.ipcSendSync(IPC_CHANNEL.CONNECT_DEVICE.GET, deviceId);
  }

  put(device: ConnectDevice): Observable<ConnectDeviceSchema> {
    return this.ipcSendSync(IPC_CHANNEL.CONNECT_DEVICE.PUT, device);
  }
}
